import c from '../common';

export default{
    "customer":"顧客",
    "customerTel":"顧客電話",
    "VNumber":"記錄編號",
    "AppliedTime":"創建時間",
    "ValidTime":"有效時間",
    "deliveryAddress":"送貨地址",
    "deliveryDate":"送貨時間",
    "NoName":"無名稱",
    "ordered":"已下單",
    "orderDetail":"預約詳情",
    "qty":"張",
    "orderContent":"預約內容",
    "NA":"暫無",
    "orderType":"種類",
};